var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement } from 'lit/decorators.js';
let FullScreenModal = class FullScreenModal extends LitElement {
    handleCloseModal() {
        this.dispatchEvent(new CustomEvent('close-modal', { bubbles: true, composed: true }));
    }
    render() {
        return html `
      <div class="modal-content">
        <simple-button
          class="close-button"
          @button-click=${this.handleCloseModal}
          label="x"
          variant="danger"
        ></simple-button>
        <slot></slot>
      </div>
    `;
    }
};
FullScreenModal.styles = css `
    :host {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 1000;
    }

    .modal-content {
      position: relative;
      background-color: white;
      width: 100%;
      height: 100%;
      padding: 0;
      box-sizing: border-box;
      overflow: auto;
    }

    .close-button {
      position: absolute;
      top: 10px;
      right: 10px;
      z-index: 1001;
    }

    slot {
      display: block;
      width: 100%;
      height: 100%;
    }
  `;
FullScreenModal = __decorate([
    customElement('full-screen-modal')
], FullScreenModal);
export { FullScreenModal };
//# sourceMappingURL=FullScreenModal.js.map